
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-parlor-places/[id]",
      function () {
        return require("private-next-pages/gangwon-parlor-places/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-parlor-places/[id]"])
      });
    }
  